import camelCase from 'lodash/camelCase';

import { HighestTrainingDegreeEnum, SchoolOptionsEnum } from '@thinknet-gmbh/platform-common';


const inputTypes = {
  text: 'text',
  select: 'select',
};

export const getEducationAndSkillsData = (t: Function) => [
  {
    groupName: 'schoolEducations',
    groupItems: [
      {
        titleFieldName: 'schoolName',
        descriptionFieldName: 'schoolEducationDescription',
        inputType: inputTypes.select,
        selectOptions: Object.keys(SchoolOptionsEnum).map(name => ({
          label: t(`employee:labels.schoolOptions.${camelCase(name.toLowerCase())}`),
          value: name,
        })),
      },
    ],
  },
  {
    groupName: 'universityEducations',
    groupItems: [
      {
        titleFieldName: 'universityName',
        descriptionFieldName: 'universityEducationDescription',
        inputType: inputTypes.text,
      },
    ],
  },
  {
    groupName: 'furtherEducations',
    groupItems: [
      {
        titleFieldName: 'furtherName',
        descriptionFieldName: 'furtherEducationDescription',
        inputType: inputTypes.text,
      },
    ],
  },
  {
    groupName: 'driversLicenses',
    groupItems: [
      {
        titleFieldName: 'driversLicenses',
        descriptionFieldName: 'driversLicensesDescription',
        inputType: inputTypes.select,
      },
    ],
  },
  {
    groupName: 'trainingEducations',
    groupItems: [
      {
        titleFieldName: 'highestTrainingDegree',
        inputType: inputTypes.select,
        selectOptions: Object.keys(HighestTrainingDegreeEnum).map(name => ({
          label: t(`employee:labels.highestTrainingOptions.${camelCase(name.toLowerCase())}`),
          value: name,
        })),
      },
      {
        titleFieldName: 'trainingName',
        descriptionFieldName: 'trainingDescription',
        inputType: inputTypes.text,
      },
    ],
  },
];
